import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormHtmlField from 'modules/ui/editform/fields/EditFormHtmlField';
import FejezetEditService from 'app/admin/fejezet/service/FejezetEditService';
import EsetleirasEditService from 'app/admin/esetleiras/service/EsetleirasEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import FmStorageTableService from 'app/admin/fileManager/service/FmStorageTableService';
import FmBrowserTableService from 'app/admin/fileManager/service/FmBrowserTableService';
import nBossConnection from 'modules/base/service/nBossConnection';

const config = {
	key: 'esetleirasEditForm',
	text: 'Esetleírások',
	textKey: 'esetleiras',
	service: EsetleirasEditService,
	icon: 'person',
	fields: [
		{
			key: 'nev',
			text: 'Név',
			textKey: 'nev',
			component: EditFormHtmlField,
			storageService: FmStorageTableService,
			browserService: FmBrowserTableService,
			getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
			required: true
		},
		{
			key: 'csorszam',
			text: 'Sorszám',
			textKey: 'csorszam',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'feladatCsoport',
			text: 'Feladatcsoport',
			textKey: 'feladatCsoport',
			component: EditFormSelectField,
			required: true,
			items: () => FejezetEditService.getFeladatCsoportSelection()
		}
	]
};

function EsetleirasEditForm() {
	return <EditFormPage config={config} />;
}

export default EsetleirasEditForm;
